import { useGenerateBestPractices } from "../../api/productSummary";
import { BestPracticeExplorer } from "./component/BestPracticeExplorer";

const dummyData = {
  foodData: [
    {
      _id: "65724c07cf878d56e2cc7663",
      processingName: "Conveyor",
      processNumber: 1,
      processingIngredient: [],
      cipSip: [],
      processingType: 1,
      machineModelNo: "",
      capacity: 30000,
      input: 40000,
      output: 40000,
      sideStream: 0,
      heat: 0,
      electricity: 5,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-07T22:49:43.403Z",
      updatedAt: "2023-12-08T10:22:44.252Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "65724d32cf878d56e2cc76cb",
      processingName: "Washing",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      cipSip: [],
      processingType: 3,
      machineModelNo: "",
      capacity: 30000,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 7.5,
      water: 2,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-07T22:54:42.271Z",
      updatedAt: "2023-12-08T13:33:46.247Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "65724d87cf878d56e2cc76e1",
      processingName: "Mechanical selection for sorting",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      cipSip: [],
      processingType: 2,
      machineModelNo: "",
      capacity: 30000,
      input: 20000,
      output: 19000,
      sideStream: 1000,
      heat: 0,
      electricity: 1.5,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-07T22:56:07.793Z",
      updatedAt: "2023-12-08T13:33:54.383Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "65724df8cf878d56e2cc76f7",
      processingName: "Conveyor belt for manual selection for sorting",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      cipSip: [],
      processingType: 4,
      machineModelNo: "",
      capacity: 30000,
      input: 19000,
      output: 18500,
      sideStream: 500,
      heat: 0,
      electricity: 1.5,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-07T22:58:00.719Z",
      updatedAt: "2023-12-08T13:34:01.878Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f00ccf878d56e2cc7af6",
      processingName: "Washing with alkaline solution",
      processNumber: 1,
      processingIngredient: [],
      processingType: 5,
      machineModelNo: "",
      capacity: 30000,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 0.5,
      water: 3,
      citricAcid: 0.002,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:29:32.194Z",
      updatedAt: "2023-12-08T13:35:14.447Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f022cf878d56e2cc7b0c",
      processingName: "Brush",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 6,
      machineModelNo: "",
      capacity: 30000,
      input: 18500,
      output: 18500,
      sideStream: 0,
      heat: 0,
      electricity: 11,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:29:54.499Z",
      updatedAt: "2023-12-08T13:34:11.291Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f070cf878d56e2cc7b22",
      processingName: "Washing/ Rinsing",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 7,
      machineModelNo: "",
      capacity: 30000,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 0,
      water: 6,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:31:12.379Z",
      updatedAt: "2023-12-08T13:35:40.158Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f088cf878d56e2cc7b38",
      processingName: "Conveyor belt  for internal transport",
      processNumber: 1,
      processingIngredient: [],
      processingType: 8,
      machineModelNo: "",
      capacity: 30000,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 2.5,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:31:36.586Z",
      updatedAt: "2023-12-08T13:36:30.994Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f09dcf878d56e2cc7b4e",
      processingName: "Size calibrator",
      processNumber: 1,
      processingIngredient: [],
      processingType: 9,
      machineModelNo: "",
      capacity: 30000,
      input: 18500,
      output: 18500,
      sideStream: 0,
      heat: 0,
      electricity: 4,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:31:57.888Z",
      updatedAt: "2023-12-08T13:37:05.048Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f0b8cf878d56e2cc7b64",
      processingName: "Conveyor belt for juice extraction",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 10,
      machineModelNo: "",
      capacity: 30000,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 4,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:32:24.602Z",
      updatedAt: "2023-12-08T13:39:11.168Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f0d9cf878d56e2cc7b7a",
      processingName: "Juice extraction",
      processNumber: 1,
      processingIngredient: [],
      processingType: 11,
      machineModelNo: "",
      capacity: 35000,
      input: 18500,
      output: 10000,
      sideStream: 8500,
      heat: 0,
      electricity: 105,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:32:57.186Z",
      updatedAt: "2023-12-08T13:36:55.298Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f146cf878d56e2cc7b90",
      processingName: "Balance Tank: Juice RAW",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 12,
      machineModelNo: "",
      capacity: 0,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 0,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:34:46.752Z",
      updatedAt: "2023-12-08T10:34:46.752Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f15fcf878d56e2cc7ba6",
      processingName: "Straining step 1",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 13,
      machineModelNo: "UPF100",
      capacity: 13600,
      input: 10000,
      output: 9400,
      sideStream: 600,
      heat: 0,
      electricity: 11,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:35:11.153Z",
      updatedAt: "2023-12-08T13:35:32.278Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f196cf878d56e2cc7bd5",
      processingName: "Straining step 2",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 14,
      machineModelNo: "UPF100",
      capacity: 13600,
      input: 9400,
      output: 9000,
      sideStream: 0,
      heat: 0,
      electricity: 11,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:36:06.106Z",
      updatedAt: "2023-12-08T13:35:22.599Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f1b0cf878d56e2cc7beb",
      processingName: "Straining step 3",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 15,
      machineModelNo: "UCF110",
      capacity: 9070,
      input: 2000,
      output: 1500,
      sideStream: 500,
      heat: 0,
      electricity: 7.5,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:36:32.893Z",
      updatedAt: "2023-12-08T13:36:19.200Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f1d2cf878d56e2cc7c01",
      processingName: "Balance Tank: Juice without cells",
      processNumber: 1,
      processingIngredient: [],
      machineModelNo: "",
      capacity: 0,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 2.2,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:37:06.463Z",
      updatedAt: "2023-12-08T10:37:06.463Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f1f4cf878d56e2cc7c17",
      processingName: "Heating to deactivate the juice enzymes",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 17,
      machineModelNo: "TETRAPAK",
      capacity: 11000,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 9,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:37:40.836Z",
      updatedAt: "2023-12-08T13:36:11.156Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f212cf878d56e2cc7c2d",
      processingName: "Vacuum with heat for essential oil adjustment",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 18,
      machineModelNo: "FLAVORTECH-SCC",
      capacity: 10000,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 34,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:38:10.684Z",
      updatedAt: "2023-12-08T13:37:24.583Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f282cf878d56e2cc7c43",
      processingName: "Sinking the pulp adjustment",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 19,
      machineModelNo: "ALFA LAVAL-BRPX717",
      capacity: 50000,
      input: 10000,
      output: 9700,
      sideStream: 300,
      heat: 0,
      electricity: 75,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:40:02.497Z",
      updatedAt: "2023-12-08T13:39:03.543Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f507cf878d56e2cc7c5e",
      processingName: "Balance Tank: Sunk Juice",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 20,
      machineModelNo: "",
      capacity: 0,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 4,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:50:47.818Z",
      updatedAt: "2023-12-08T10:50:47.818Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f528cf878d56e2cc7c74",
      processingName: "Debittering",
      processNumber: 1,
      processingIngredient: [],
      processingType: 21,
      machineModelNo: "Koch Separation Solutions",
      capacity: 12000,
      input: 9700,
      output: 9700,
      sideStream: 0,
      heat: 0,
      electricity: 130,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:51:20.311Z",
      updatedAt: "2023-12-08T13:39:19.734Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f557cf878d56e2cc7c8a",
      processingName: "Balance Tank: Debittered Juice",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 22,
      machineModelNo: "",
      capacity: 0,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 2,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:52:07.745Z",
      updatedAt: "2023-12-08T10:52:07.745Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f58bcf878d56e2cc7ca0",
      processingName: "Pasteurization",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 23,
      machineModelNo: "APV",
      capacity: 15000,
      input: 9700,
      output: 9300,
      sideStream: 400,
      heat: 0,
      electricity: 40,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:52:59.439Z",
      updatedAt: "2023-12-08T13:35:48.906Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f5aacf878d56e2cc7cb6",
      processingName: "Chilled Aseptic Storage",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 24,
      machineModelNo: "",
      capacity: 0,
      input: 0,
      output: 0,
      sideStream: 0,
      heat: 0,
      electricity: 6,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:53:30.242Z",
      updatedAt: "2023-12-08T13:36:00.282Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f667cf878d56e2cc7cd1",
      processingName: "Machine: Aseptic processing for DRUM Filling",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 25,
      machineModelNo: "Scholle AF 10-2E",
      capacity: 10000,
      input: 9300,
      output: 9100,
      sideStream: 200,
      heat: 0,
      electricity: 4,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:56:39.843Z",
      updatedAt: "2023-12-08T10:56:39.843Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    },
    {
      _id: "6572f6b6cf878d56e2cc7cf1",
      processingName: "Aseptic processing for DRUM Filling",
      processNumber: 1,
      facilityId: {
        _id: "65724c5acf878d56e2cc768c",
        tenantId: "6571d041cf878d56e2cc745d",
        createdAt: "2023-12-06T10:07:09.889Z",
        updatedAt: "2023-12-06T10:07:09.889Z",
        facilityName: "CHB",
        facilityAddress: "Greece",
        facilityCity: "Manila",
        facilityCountry: 36,
        facilityType: "FACTORY",
        energy: [
          {
            EnergyType: 1,
            kWh: 100,
            Percentage: 70
          },
          {
            EnergyType: 1,
            kWh: 43,
            Percentage: 30
          }
        ],
        status: "ACTIVE",
        __v: 0,
        heatSource: [],
        waterSource: [],
        facilityOwnership: "Internal",
        refrigerantSource: [],
        isSimulatedFacility: false,
        originalId: null
      },
      processingIngredient: [],
      processingType: 25,
      machineModelNo: "Scholle AF 10-2E",
      capacity: 10000,
      input: 9300,
      output: 9100,
      sideStream: 200,
      heat: 0,
      electricity: 4,
      water: 0,
      citricAcid: 0,
      processingStatus: "ACTIVE",
      createdAt: "2023-12-08T10:57:58.554Z",
      updatedAt: "2023-12-08T13:36:39.574Z",
      __v: 0,
      ownerId: "657248f5cf878d56e2cc75cb",
      sourceId: "657248f5cf878d56e2cc75d2",
      dataType: "SPECIFIC",
      capacityUnit: 1,
      electricityUnit: 5,
      heatUnit: 3,
      inputUnit: 1,
      outputUnit: 1,
      sideStreamUnit: 1,
      waterUnit: 7
    }
  ]
};

const BestPracticesSimulation = () => {
  const { data, mutate } = useGenerateBestPractices();

  return (
    <div className="min-h-screen">
      <div className="mx-auto py-8">
        <BestPracticeExplorer />
      </div>
    </div>
  );
};

export default BestPracticesSimulation;
